'use strict';
angular
    .module('dnapp')
    .controller('DNDepartments.NewsListController', ['DNDepartments.NewsListService', '$filter', function (newsListService, $filter) {
        var vm = this;
        vm.news = [];
        vm.currentNews = 4;
        vm.hideButton = false;

        var page = 2;
        var totalNews = $('#js-total-news').data('total-news');
        var nodeId = $('#js-section-header').data('node-id');

        if (totalNews < 4) {
            vm.currentNews = totalNews;
        }

        if (vm.currentNews === totalNews) {
            vm.hideButton = true;
        }

        function fixImages() {
            novicell.responsiveLazyloadImage.image();
        }

        vm.getImageDescription = function (image) {
            if (image.showDescription) {
                return $filter('filter')(image.properties, 'description')[0].value;
            }
            return "";
        }

        vm.getImagePhotographer = function (image) {
            if (image.showPhotographer) {
                return $filter('filter')(image.properties, 'photographer')[0].value;
            }
            return "";
        }

        this.loadMoreNews = function () {
            newsListService.getNews({ nodeId: nodeId, page: page }).$promise.then(function (result) {
                if (result.Success) {
                    page++;
                    vm.currentNews += result.Data.length;

                    $.merge(vm.news, result.Data);

                    setTimeout(fixImages, 200);

                    if (vm.currentNews === totalNews) {
                        vm.hideButton = true;
                    }
                } else {
                    console.log("ERROR: " + result.ErrorMessage);
                }
            });
        }
    }]);